export var Placements;
(function (Placements) {
    Placements["bottomLeft"] = "bottomLeft";
    Placements["bottomCenter"] = "bottomCenter";
    Placements["bottomRight"] = "bottomRight";
    Placements["topLeft"] = "topLeft";
    Placements["topCenter"] = "topCenter";
    Placements["topRight"] = "topRight";
})(Placements || (Placements = {}));
